import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '../../atoms';
import { StyledCtaButton } from './styles.js';

export const CtaButton = ({
  children,
  href,
  variant,
  onClick,
  fullWidth = false,
}) => {
  return (
    // Would it make sense for CTA button to just extend LinkButton rather than wrap it?
    <StyledCtaButton>
      <LinkButton
        href={href}
        variant={variant}
        horizontalPadding={12}
        verticalPadding={4}
        minWidth={240}
        onClick={onClick}
        hoverIcon="arrow-forward"
        fullWidth={fullWidth}
      >
        {children}
      </LinkButton>
    </StyledCtaButton>
  );
};

CtaButton.displayName = 'CtaButton';

CtaButton.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
};
